<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20px"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
  >
    <path d="M12 16v-4" />
    <path d="M12 8h.01" />
    <circle cx="12" cy="12" r="10" />
  </svg>
</template>
